import React from 'react';

export const Location = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_2474_4627)">
                <mask
                    id="mask0_2474_4627"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                >
                    <rect width="24" height="24" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_2474_4627)">
                    <path
                        d="M10.0002 9.99935C10.4585 9.99935 10.8509 9.83615 11.1772 9.50977C11.5036 9.18338 11.6668 8.79102 11.6668 8.33268C11.6668 7.87435 11.5036 7.48199 11.1772 7.1556C10.8509 6.82921 10.4585 6.66602 10.0002 6.66602C9.54183 6.66602 9.14947 6.82921 8.82308 7.1556C8.49669 7.48199 8.3335 7.87435 8.3335 8.33268C8.3335 8.79102 8.49669 9.18338 8.82308 9.50977C9.14947 9.83615 9.54183 9.99935 10.0002 9.99935ZM10.0002 16.1243C11.6946 14.5688 12.9516 13.1556 13.771 11.8848C14.5904 10.6139 15.0002 9.48546 15.0002 8.49935C15.0002 6.98546 14.5175 5.74588 13.5522 4.7806C12.587 3.81532 11.4029 3.33268 10.0002 3.33268C8.59738 3.33268 7.41336 3.81532 6.44808 4.7806C5.4828 5.74588 5.00016 6.98546 5.00016 8.49935C5.00016 9.48546 5.40989 10.6139 6.22933 11.8848C7.04877 13.1556 8.30572 14.5688 10.0002 16.1243ZM10.0002 18.3327C7.76405 16.4299 6.09391 14.6625 4.98975 13.0306C3.88558 11.3987 3.3335 9.88824 3.3335 8.49935C3.3335 6.41602 4.00363 4.75629 5.34391 3.52018C6.68419 2.28407 8.23627 1.66602 10.0002 1.66602C11.7641 1.66602 13.3161 2.28407 14.6564 3.52018C15.9967 4.75629 16.6668 6.41602 16.6668 8.49935C16.6668 9.88824 16.1147 11.3987 15.0106 13.0306C13.9064 14.6625 12.2363 16.4299 10.0002 18.3327Z"
                        fill="#252733"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_2474_4627">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
